<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.teachers', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-2 md:grid-cols-2">
            <div class="relative col-span-1 flex shadow rounded-md" v-for="teacher in teachers">
                <div
                    class="shrink-0 flex items-center justify-center w-24 text-white text-sm leading-5 font-medium rounded-l-md overflow-hidden"
                >
                    <InertiaLink :href="teacher.links.show">
                        <img :src="teacher.avatar_or_default" alt="profile photo" />
                    </InertiaLink>
                </div>
                <div
                    class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate"
                >
                    <div class="flex-1 px-4 py-2 text-sm leading-5 truncate">
                        <div>
                            <InertiaLink
                                :href="teacher.links.show"
                                class="text-gray-900 font-medium hover:text-gray-600 transition ease-in-out duration-150"
                            >
                                {{ teacher.full_name }}
                            </InertiaLink>
                            <span v-if="teacher.group_name"> ({{ teacher.group_name }}) </span>
                        </div>

                        <div class="text-xs">
                            <div>
                                {{ teacher.email }}
                            </div>
                            <div v-if="teacher.secondary_email">
                                {{ teacher.secondary_email }}
                            </div>
                            <div v-if="teacher.phone_number">
                                {{ teacher.phone_number }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';

export default {
    components: {
        PanelPage,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'teachers', 'filters', 'options'],
    data() {
        return {};
    },
    methods: {},
};
</script>
